import { Glasses, Sun } from "lucide-react";

const LINKS = [
  ["Mission", "#mission", "nav-link-mission"],
  ["Growth Path", "#growth-path", "nav-link-growth-path"],
  ["Currently Working", "#how-it-works", "nav-link-how-it-works"],
  ["The App", "#inside-the-app", "nav-link-inside-the-app"],
  ["Engine", "#engine", "nav-link-engine"],
  ["Privacy", "#privacy", "nav-link-privacy"],
  ["Simulator", "#simulator", "nav-link-simulator"],
];

export const scrollToHash = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Header({ theme, onToggleTheme }) {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-[var(--sp-line)] backdrop-blur-md"
      style={{ background: "color-mix(in srgb, var(--sp-bg) 88%, transparent)" }}
    >
      <div className="mx-auto flex h-16 max-w-[1500px] items-center justify-between px-5 sm:px-8">
        <a
          href="#top"
          onClick={(e) => scrollToHash(e, "#top")}
          data-testid="logo-link"
          className="font-display text-xl font-black uppercase tracking-tight sm:text-2xl"
        >
          ShadyParking<span className="text-[var(--sun)]">.Space</span>
        </a>
        <nav className="hidden items-center gap-7 lg:flex" data-testid="site-nav">
          {LINKS.map(([label, href, id]) => (
            <a
              key={href}
              href={href}
              data-testid={id}
              onClick={(e) => scrollToHash(e, href)}
              className="font-mono2 text-[11px] uppercase tracking-[0.16em] text-[var(--sp-muted)] transition-colors duration-300 hover:text-[var(--sun)]"
            >
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <div
            data-testid="privacy-status-badge"
            className="hidden items-center gap-2 border border-[var(--sp-line)] px-3 py-1.5 sm:flex"
          >
            <span className="relative flex h-1.5 w-1.5">
              <span className="sp-ping absolute inline-flex h-full w-full bg-[var(--sun)]" />
              <span className="relative inline-flex h-1.5 w-1.5 bg-[var(--sun)]" />
            </span>
            <span className="font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-muted)]">
              Anonymous Engine
            </span>
          </div>
          <button
            type="button"
            data-testid="contrast-toggle-button"
            onClick={onToggleTheme}
            aria-label="Toggle high-contrast mode"
            className="group flex h-9 w-9 items-center justify-center border border-[var(--sp-line)] transition-colors duration-300 hover:border-[var(--sun)] hover:bg-[var(--sun)]"
          >
            {theme === "dark" ? (
              <Glasses className="h-4 w-4 text-[var(--sun)] transition-colors group-hover:text-black" />
            ) : (
              <Sun className="h-4 w-4 text-[var(--sun)] transition-colors group-hover:text-black" />
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
